import { render, staticRenderFns } from "./OverlayTemplate.vue?vue&type=template&id=cea9b82e&scoped=true"
import script from "./OverlayTemplate.vue?vue&type=script&lang=js"
export * from "./OverlayTemplate.vue?vue&type=script&lang=js"
import style0 from "./OverlayTemplate.vue?vue&type=style&index=0&id=cea9b82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea9b82e",
  null
  
)

export default component.exports